import React, {createContext, useContext, useEffect, useState} from "react";
import {
    DialogActions,
    DialogContent,
    DialogTitle,
    useMediaQuery,
    useTheme,
    Button, Box, Alert,
} from "@mui/material";
import {subscriptionServices} from "../../../service/subscriptionService";
import Spinner from "../../spinner/Spinner";
import {Cancel} from "@mui/icons-material";
import CustomSnackbar from "../../alert/CustomSnackbar";
import {SubscriptionDialog as Dialog} from "./SubscriptionDesign";

export const CancelSubscriptionContext = createContext(null);

function CancelSubscription(props) {
    const [planName, setPlanName] = useState("");
    const [loading, setLoading] = useState(true);
    const [loadingCancelReq, setLoadingCancelReq] = useState(false);
    const [details, setDetails] = useState(null);
    const [errorMsg, setErrorMsg] = useState("");
    const [billingDetails, setBillingDetails] = useState(null);

    useEffect(() => {
        async function fetchData() {
            await subscriptionServices.fetchSubscription(true, true, true, true, true).then((result) => {
                setDetails(result);
            }).catch(() => {
            }).finally(() => {
                setLoading(false);
            });
        }

        if (details === null && props?.open) {
            fetchData();
        }
    }, [details, props.open]);

    return (
        <CancelSubscriptionContext.Provider
            value={{
                planName, setPlanName,
                loading, setLoading,
                loadingCancelReq, setLoadingCancelReq,
                details, setDetails,
                setErrorMsg, errorMsg,
                billingDetails, setBillingDetails
            }}>
            <CancelForm {...props}/>
        </CancelSubscriptionContext.Provider>
    );
}

const CancelForm = (props) => {
    const {loading, details, setErrorMsg, errorMsg, loadingCancelReq, setLoadingCancelReq} = useContext(CancelSubscriptionContext);
    const {onClose, open} = props;

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const handleOnClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return false;
        }
        onClose();
    };

    const cancelSubscription = async () => {
        setLoadingCancelReq(true);
        setErrorMsg("");
        await subscriptionServices.cancel().then(() => {
            onClose();
        }).catch((e) => {
            setErrorMsg(e?.response?.data?.error);
        }).finally(() => {
            setLoadingCancelReq(false);
        });
    };

    return (
        <Dialog
            open={open}
            onClose={handleOnClose}
            fullWidth={true}
            fullScreen={fullScreen}
            aria-labelledby="cancel-subscription"
            maxWidth="md"
        >
            {loading && <Spinner size={32} overComponentBox={true}/>}
            {loadingCancelReq && <Spinner size={32} overComponentBox={true}/>}

            <DialogTitle id="cancel-subscription">
                Cancel subscription
            </DialogTitle>

            {errorMsg !== "" &&
                <CustomSnackbar message={errorMsg} timeout={2500} severity={"error"}/>
            }

            {!loading && <DialogContent>

                <Box display="flex" flexDirection="column">
                    <Box pt={3}>
                        Your subscription will remain active until <strong>{details?.plan?.currentPeriodEnd}</strong>.
                        <br/>After that date, it will be automatically canceled and you won’t be charged again.
                    </Box>

                    <Alert severity="warning" color="warning" variant="filled" sx={{mt: 2}}>
                        Please note that usage-based overage charges may still apply if your event limits are exceeded
                        before the cancellation date.
                    </Alert>

                    <Box pt={6} sx={{textAlign: "center"}}>
                        <Button type="button" variant="contained" color="error" onClick={cancelSubscription}>
                            <Cancel sx={{fontSize: "16px", marginRight: 1}}/> Cancel Subscription
                        </Button>
                    </Box>
                </Box>

            </DialogContent>}
            <DialogActions sx={{padding: "15px"}}>
                <Button type="button" color="inherit" variant="text" onClick={handleOnClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CancelSubscription;